/**
 * Entry in a Monero output histogram (see get_output_histogram of Daemon RPC documentation).
 */
export default class MoneroOutputHistogramEntry {
    constructor(entry) {
        Object.assign(this, entry);
        if (this.amount !== undefined && typeof this.amount !== "bigint")
            this.amount = BigInt(this.amount);
    }
    toJson() {
        let json = Object.assign({}, this);
        if (json.amount !== undefined)
            json.amount = json.amount.toString();
        return json;
    }
    getAmount() {
        return this.amount;
    }
    setAmount(amount) {
        this.amount = amount;
        return this;
    }
    getNumInstances() {
        return this.numInstances;
    }
    setNumInstances(numInstances) {
        this.numInstances = numInstances;
        return this;
    }
    getNumUnlockedInstances() {
        return this.numUnlockedInstances;
    }
    setNumUnlockedInstances(numUnlockedInstances) {
        this.numUnlockedInstances = numUnlockedInstances;
        return this;
    }
    getNumRecentInstances() {
        return this.numRecentInstances;
    }
    setNumRecentInstances(numRecentInstances) {
        this.numRecentInstances = numRecentInstances;
        return this;
    }
}
